<div class="inputgroup">
  <label>{{'Vehicle type'|translate}}</label>
  <input [readonly]="!canEditTrackers" type="text" [(ngModel)]="model.Type"/>
</div>
<div class="inputgroup">
  <label>{{'License plate'|translate}}</label>
  <input [readonly]="!canEditTrackers" type="text" [(ngModel)]="model.StateNumber"/>
</div>
<div class="inputgroup">
  <label>{{'VIN number'|translate}}</label>
  <input [readonly]="!canEditTrackers" type="text" [(ngModel)]="model.VinNumber"/>
</div>
<div class="inputgroup">
  <label>{{'Model'|translate}}</label>
  <input [readonly]="!canEditTrackers" type="text" [(ngModel)]="model.ModelName"/>
</div>
<div class="inputgroup">
  <label>{{'Brand'|translate}}</label>
  <input [readonly]="!canEditTrackers" type="text" [(ngModel)]="model.BrandName"/>
</div>
<div class="inputgroup">
  <label>{{'Vehicle year'|translate}}</label>
  <input [readonly]="!canEditTrackers" type="text" [(ngModel)]="model.Year"/>
</div>
<div class="inputgroup">
  <label>{{'Color'|translate}}</label>
  <input [readonly]="!canEditTrackers" type="text" [(ngModel)]="model.Color"/>
</div>
<div class="inputgroup">
  <label>{{'Vehicle fuel type'|translate}}</label>
  <input [readonly]="!canEditTrackers" type="text" [(ngModel)]="model.FuelType"/>
</div>
<div class="inputgroup">
  <label>{{'Engine power'|translate}}</label>
  <label>
    <input [readonly]="!canEditTrackers" type="number" [min]="0" [(ngModel)]="model.EngineP" (input)="checkEngPower($event)" />
    <span>{{'kW'|translate}}</span>
  </label>
</div>
<div class="inputgroup">
  <label>{{'Engine volume'|translate}}</label>
  <label>
    <input [readonly]="!canEditTrackers" type="number" [min]="0" [(ngModel)]="model.EngineV" (input)="checkEngVolume($event)" />
    <span>{{'cm3'|translate}}</span>
  </label>
</div>
